import { memo } from 'react';
import { maskCPF, maskCNPJ } from '@alamo/utils';

import { cn } from '../../../lib/cn';

interface DocumentCellProps {
  value: string | null | undefined;
  type?: 'cpf' | 'cnpj' | 'auto';
  className?: string;
}

function formatDocument(value: string, type: 'cpf' | 'cnpj' | 'auto'): string {
  const digits = value.replace(/\D/g, '');

  if (type === 'cpf') return maskCPF(digits);
  if (type === 'cnpj') return maskCNPJ(digits);

  // Auto-detect by digit count
  if (digits.length <= 11) return maskCPF(digits);
  return maskCNPJ(digits);
}

export const DocumentCell = memo(function DocumentCell({
  value,
  type = 'auto',
  className,
}: DocumentCellProps) {
  if (!value) {
    return <span className="text-slate-400">-</span>;
  }

  return (
    <span className={cn('font-mono text-sm tabular-nums', className)}>
      {formatDocument(value, type)}
    </span>
  );
});
